import BossBabyChatLogSessionList from './SessionList';
import BossBabyChatLogSessionDetail from './SessionDetail';

export default {
  SessionList: BossBabyChatLogSessionList,
  SessionDetail: BossBabyChatLogSessionDetail,
};









